export enum UserStatus {
	ACTIVE = 'Active',
	INACTIVE = 'Inactive',
}

export enum LoggedInUserGroup {
	ROLE_BUSINESS_VALUE = 'Business',
	ROLE_COMPLIANCE_VALUE = 'Compliance',
	ROLE_ADMIN_VALUE = 'Administrator',
	ROLE_LEGAL_VALUE = 'Legal',
}

export enum LoggedInRole {
	ROLE_LEGAL_REVIEWER = 'Legal Reviewer',
	ROLE_LEGAL_ANALYST = 'Legal Analyst',
	ROLE_LEGAL_APPROVER = 'Legal Approver',
	ROLE_COMPLIANCE_ANALYST = 'Compliance Analyst',
	ROLE_COMPLIANCE_APPROVER = 'Compliance Approver',
	ROLE_COMPLIANCE_REVIEWER = 'Compliance Reviewer',
	ROLE_BUSINESS_ANALYST = 'Business Analyst',
	ROLE_BUSINESS_APPROVER = 'Business Approver',
	ROLE_BUSINESS_REVIEWER = 'Business Reviewer',
	ROLE_OPERATIONS_MANAGER = 'Operational Manager',
	ROLE_USER_ADMINISTRATOR = 'User Administrator',
	ROLE_SYSTEM_ADMINISTRATOR = 'System Administrator',
	ROLE_APPLICABILITY_ANALYST = 'Regulatory Applicability Analyst',
	ROLE_APPLICABILITY_LEGAL_MANAGER = 'Regulatory Applicability Legal Manager',
	ROLE_GROUPING_ANALYST = 'Regulatory Grouping Analyst',
	ROLE_GROUPING_MANAGER = 'Regulatory Grouping Manager',
	ROLE_SUMMARY_ANALYST = 'Regulatory Analyst Manager',
	ROLE_SUMMARY_MANAGER = 'Regulatory Summary Manager',
	ROLE_MAPPING_ANALYST = 'Regulatory Mapping Analyst',
	ROLE_MAPPING_MANAGER = 'Regulatory Mapping Manager',
	ROLE_DEMO_USER = 'Demo User',
	ROLE_INVENTORY_APPROVER = 'Content Library Approver',
	ROLE_INVENTORY_MANAGER = 'Content Library Manager',
}

export enum LoggedInUserTermsAndPolicyStatus {
	ACCEPTED = 'accepted',
	DECLINED = 'declined',
}

export enum TermsAndPolicyStatementLink {
	TERMS_OF_USE = 'https://productcentral.products.pwc.com/us/en/legal/terms-of-use.html',
	POLICY_STATEMENT = 'https://privacyhub.pwc.com/us/en/risk-link/privacy-policy.html',
}

export enum TermsAndPolicyDisplayText {
	TERMS_POLICY_MODAL_TITLE = 'Terms of Use and Privacy Statement',
	TERMS_OF_USE_TEXT = 'Terms of Use',
	POLICY_STATEMENT_TEXT = 'Privacy Statement',
}
